import { requestQuery } from '@/services/request';
import { coreLogoutRoute } from '@/modules/auth/domain/routes/authRoutes';

export const postLogout = () =>
  requestQuery<void>({
    method: 'POST',
    url: coreLogoutRoute,
  });
